<template>
  <text-input-label :class="style.inputSuggestions"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @keyup="$emit('keyup', $event)"
    @focus="$emit('focus', $event)"
    :customInputStyles="customInputStyles"
    :value="value"
    :disabled="disabled"
    :name="name"
    :autocomplete="'off'"
    :size="size"
    :placeholder="placeholder"
    :error="error">
    <slot></slot>
    <template #bottom>
      <slot name="bottom"></slot>
    </template>
  </text-input-label>
  
</template>

<script>
  import style from './style.module.scss'

  import $ from 'jquery';
  import 'suggestions-jquery';

  import textInputLabel from '@/components/controls/text-input-label/text-input-label.vue'

  import config from '@/config'

  export default {
    name: 'name-input-suggestions-v2',
    components: {
      textInputLabel,
      // inputLabel
    },
    props: {
      id: {
        type: String,
        default: '',
        required: false
      },
      value: {
        type: String,
        default: '',
        required: false
      },
      name: {
        type: String,
        default: 'inputName',
        required: true
      },
      size: {
        type: String,
        default: 'mid',
        required: false
      },
      placeholder: null,
      type: {
        default: 'PARTY'
      },
      suggestionCount: null,
      deferRequestBy: {
        type: Number,
        default: 100
      },
      customInputStyles: {
				type: Array,
				default() {
          return [];
        }
			},
      disabled: {
				type: Boolean,
				default: false
			},
      enabledDadata: {
        type: Boolean,
        default: true
      },
      hideSuggestion: {
        type: Boolean,
        default: false
      },
      error: Boolean
    },
    data() {
      return {
        style: style,
        items: null,
        value1: null,
        options: {
          // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
          token: config.dadataToken,
          type: this.type,
          scrollOnFocus: false,
          triggerSelectOnBlur: false,
          triggerSelectOnEnter: true,
          noSuggestionsHint: false,
          addon: 'none',
          noCache: true,
          deferRequestBy: this.deferRequestBy,
          // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
          // onSelect (suggestion) {
          //   console.log('object');
          // },
          // onSearchComplete(query, suggestions){
          //   console.log('object');
          // },
          // onSearchError(query, jqXHR, textStatus, errorThrown){
          //   console.log('object');
          // }
        }
      }
    },

    methods: {
      initSuggestion() {
        this.callbacks.add(this.onSelect);
        this.callbacks.add(this.options.onSelect || $.noop)
        this.callbacks.add(this.options.onSearchComplete || $.noop)
        this.callbacks.add(this.options.onSearchError || $.noop)        
        const options = Object.assign({}, this.options, {
          onSelect: suggestion => this.callbacks.fire(suggestion),
          onSearchComplete: (query, suggestions) => {  
            if (suggestions && suggestions.length === 0){
              this.$emit("items-not-found");
            }
            if (suggestions && suggestions.length > 0){
              this.$emit("items-found");
            }          
          },
          onSearchError: (query, jqXHR, textStatus, errorThrown) => {
            if (query && query != ""){
              this.$emit("dadata-error");
            }
          },
          count: this.suggestionCount
        });
        $(this.$el).find('input').suggestions(options);
        $(this.$el).find('input').removeClass('suggestions-input');

        if (this.hideSuggestion == true){
          $(this.$el).find('input').suggestions().disable();
        }
      },
      destroySuggestion() {
        const plugin = $(this.$el).find('input').suggestions();
        if (plugin){
          plugin.dispose();
        }
      },
      onSelect(suggestion) {
        this.$emit('select-name', suggestion);
        this.value1 = suggestion.value;
        //$(this.$el).find('input').blur();
      }
    },

    mounted() {
      this.callbacks = $.Callbacks();
      this.value1 = this.value;
      this.initSuggestion();
    },

    destroyed() {
      this.destroySuggestion();
    },
    watch: {
      /*
      value1() {
        this.$emit('update:model', this.value1);
      },
      value() {
        this.value1 = this.value;
      },
      */
      value1() {
        this.$emit('update:model', this.value1);
      },
      model() {
        this.value1 = this.model;
      },
      enabledDadata(){
        if (this.enabledDadata == false){
          this.destroySuggestion();
        }
      },
      hideSuggestion(){
        if (this.hideSuggestion == false){
          $(this.$el).find('input').suggestions().enable();
          this.value1 = this.value;
        }
      }
    }
  }
</script>